module.exports = __webpack_public_path__ + "img/1762863307150-ca9fptlG.f47199c2.png";